import { render, staticRenderFns } from "./SendSmsTemplate.vue?vue&type=template&id=2bcbf78f&"
import script from "./SendSmsTemplate.vue?vue&type=script&lang=js&"
export * from "./SendSmsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsTemplate.vue?vue&type=style&index=0&id=2bcbf78f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports